import { render, staticRenderFns } from "./InquiryListView.vue?vue&type=template&id=728aeda8&scoped=true"
import script from "./InquiryListView.vue?vue&type=script&lang=js"
export * from "./InquiryListView.vue?vue&type=script&lang=js"
import style0 from "./InquiryListView.vue?vue&type=style&index=0&id=728aeda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728aeda8",
  null
  
)

export default component.exports